import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { di } from 'react-magnetic-di';
import TopicsUI from 'view/help-center-topics';
import { useIsPageInEditMode } from 'view/layout-next/controllers';
import { token } from '@atlaskit/tokens';

const Topics: React.FC = () => {
    di(useIsPageInEditMode);
    const [isPageInEditMode] = useIsPageInEditMode();
    return (
        <Root>
            <TopicsUI disableAllLinks={isPageInEditMode} />
        </Root>
    );
};

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Root = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;
    margin: ${token('space.300', '24px')} auto;
`;

export default Topics;
